import React, { useState, useContext } from 'react';
import { SimpleDialog, Typography, styled } from '@nextiva/next-ui-components';
import {
  LicensesContext,
  actionTypes,
} from '../../../containers/pages/BillingLicenses/licensesContext';

const StyledDialogText = styled(Typography)`
  width: 347px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

export const NonBmlSupportedModal = () => {
  const [modalOpen, setModalOpen] = useState(true);

  const { dispatch } = useContext(LicensesContext);

  const onOkButtonClick = (): void => {
    setModalOpen(false);
    dispatch({
      type: actionTypes.TOGGLE_PURCHASE_LICENSE_MODAL,
    });
  };

  return (
    <SimpleDialog
      data-testid="PlatformAdminUI-PurchaseLicenseModal-NonBmlSupportedModal"
      confirmButtonProps={{
        color: 'primary',
        onClick: onOkButtonClick,
        'data-testid':
          'PlatformAdminUI-PurchaseLicenseModal-NonBmlSupportedModalOkButton',
      }}
      confirmText="OK"
      title="We are unable to quote this item for you"
      open={modalOpen}
    >
      <StyledDialogText variant="body2">
        If you need help purchasing this item, please contact your Account
        Manager directly.
      </StyledDialogText>
    </SimpleDialog>
  );
};
